import { useAuth } from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";

const OfflineModeBar = () => {
  const { isOnline, serverReachable } = useAuth();
  const { t } = useTranslation();

  if (isOnline && serverReachable) return null;

  // Two distinct situations, one bar: no internet vs server outage. The
  // distinction matters to clinicians ("my wifi" vs "their servers").
  const message = !isOnline ? t("layout.offlineBar") : t("layout.serverUnreachableBar");
  return <div className="offline-bar">{message}</div>;
};

export default OfflineModeBar;
